import { FloatingHeader } from '@lmig/lmds-react-floating-header';
import { getClaimsUIUrl } from 'Foundation/Configurations/GlobalConfiguration';
import { useEffect, useState } from 'react';
import IframeResizer from 'iframe-resizer-react';
import { useSearchParams } from 'react-router-dom';
import PageFooter from 'Feature/Chrome/Footer/PageFooter';
import { isOneBrand } from 'Foundation/Configurations/GlobalConfiguration';

export default function ClaimsEmailLink() {
  const [url, setUrl] = useState<string>();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    document.title = 'Claims Email Link';
    let url: string = getClaimsUIUrl();

    let claimNumber: string | null = searchParams.get('claimNumber');
    if (claimNumber) url += `&claimNumber=${claimNumber}`;

    let cmpid: string | null = searchParams.get('cmpid');
    if (cmpid) url += `&cmpid=${cmpid}`;

    let srcEnv: string | null = searchParams.get('srcEnv');
    if (srcEnv) url += `&srcEnv=${srcEnv}`;

    setUrl(url);
  }, []);

  return (
    <>
      { isOneBrand() ? 
        <FloatingHeader brand="liberty" hideDivider={true} appName={'Settings'} brandLinkProps={{ href: '/start' }} /> : 
        <FloatingHeader brand="safeco" isFullWidth={true} isFullBackground={true} brandLinkProps={{ href: '/start' }} />
      }
      <IframeResizer log={true} src={url} style={{ width: '1px', minWidth: '100%' }} checkOrigin={false} />
      <PageFooter />
    </>
  );
}
